document.addEventListener('DOMContentLoaded', () => {
  const images = document.querySelectorAll('.lazy-image');

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const img = entry.target;

      img.onload = () => {
        img.classList.add('loaded');
      };

      img.src = img.dataset.src;

      obs.unobserve(img);
    });
  }, {
    rootMargin: '300px'
  });

  images.forEach(img => observer.observe(img));
});